import api from './api';

export interface Party {
    id: number;
    name: string;
    role_default?: string;
    contact?: string;
    trigram?: string;
}

const partiesService = {
    getParties: async (): Promise<Party[]> => {
        const response = await api.get('/parties');
        return response.data;
    },

    createParty: async (data: Omit<Party, 'id'>): Promise<{ message: string; id: number }> => {
        const response = await api.post('/parties', data);
        return response.data;
    },

    deleteParty: async (id: number): Promise<{ message: string }> => {
        const response = await api.delete(`/parties/${id}`);
        return response.data;
    }
};

export default partiesService;
